import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, Input, Output, NgModule, Injectable, ViewChild } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@ng-bootstrap/ng-bootstrap';
import { map, catchError, first } from 'rxjs/operators';
import { from, throwError } from 'rxjs';
import * as i1$1 from '@segurosvoluntarios_vel/commons-services';
import { PrismicGraphqlService } from '@segurosvoluntarios_vel/commons-services';

class LibSuraModalComponent {
    constructor(ngbModal) {
        this.ngbModal = ngbModal;
        this.alignHeader = 'center';
        this.alignBody = 'left';
        this.handleSubmit = new EventEmitter();
    }
    onClose() {
        this.ngbModal.dismissAll();
    }
    onSubmit() {
        this.handleSubmit.emit();
    }
}
LibSuraModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibSuraModalComponent, deps: [{ token: i1.NgbModal }], target: i0.ɵɵFactoryTarget.Component });
LibSuraModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LibSuraModalComponent, selector: "lib-sura-modal", inputs: { alignHeader: "alignHeader", defaultButtonText: "defaultButtonText", alignBody: "alignBody", disableClose: "disableClose", type: "type" }, outputs: { handleSubmit: "handleSubmit" }, ngImport: i0, template: "<button\n  *ngIf=\"!disableClose\"\n  type=\"button\"\n  class=\"close position-absolute\"\n  aria-label=\"Close\"\n  (click)=\"onClose()\"\n>\n  <i class=\"fal fa-times\"></i>\n</button>\n<div\n  class=\"modal-body d-flex flex-column align-items-center justify-content-center d-md-block mb-2 mb-md-1 pb-md-4 px-5 pt-4 pb-2 \"\n>\n  <div\n    *ngIf=\"type === 'error'\"\n    [style.text-align]=\"alignHeader\"\n    class=\"sura-modal-header-error\"\n  >\n    <i class=\"far fa-exclamation-circle sura-modal-header-error__icon\"></i>\n    <h4 class=\"sura-modal-header-error__title\">\n      <ng-content select=\"[slot=header]\"></ng-content>\n    </h4>\n  </div>\n  <div\n    *ngIf=\"type === 'warning'\"\n    [style.text-align]=\"alignHeader\"\n    class=\"sura-modal-header-warning\"\n  >\n    <i class=\"far fa-exclamation-triangle sura-modal-header-warning__icon\"></i>\n    <h4 class=\"sura-modal-header-warning__title\">\n      <ng-content select=\"[slot=header-warning]\"></ng-content>\n    </h4>\n  </div>\n  <div [style.text-align]=\"alignBody\" class=\"sura-modal-body\">\n    <ng-content select=\"[slot=body]\"></ng-content>\n  </div>\n  <div class=\"text-center\" *ngIf=\"defaultButtonText\">\n    <button type=\"button\" class=\"sura-modal-button\" (click)=\"onSubmit()\">\n      {{ defaultButtonText }}\n    </button>\n  </div>\n  <div class=\"text-center\" *ngIf=\"!defaultButtonText\">\n    <ng-content select=\"[slot=footer]\"></ng-content>\n  </div>\n</div>\n", styles: [".modal .modal-content{border-radius:.625rem}@media (min-width: 48em){.modal .modal-content{border:.0625rem solid rgba(0,0,0,.2)}}.modal .close{outline:none;color:var(--sura-color-close-modal, #0033a0);opacity:1!important;font-size:1.6rem;right:1rem;top:.8rem;z-index:1}.modal .modal-header{border:0}.sura-modal-header-information__title{font-size:2rem;font-weight:bold;color:var(--sura-color-title-modal, #0033a0)}.sura-modal-header-error__icon{color:#ff585d;color:var(--sura-color-title-icon-error-modal, #ff585d);font-size:4rem}.sura-modal-header-error__title{color:var(--sura-color-title-error-modal, #ff585d);font-size:2.5rem}.sura-modal-header-warning__icon{color:#ed8b00;font-size:4rem}.sura-modal-header-warning__title{color:#ed8b00;font-size:2.5rem}.sura-modal-body{color:#464646;font-size:1.25rem}.sura-modal-button{font-family:var(--secondary-font-family);background-color:var(--sura-background-color-modal-button, #0033a0);font-size:1rem;color:var(--sura-color-modal-button, #fff);font-weight:700;border:0;border-radius:3.125rem;padding:.5rem 2.5rem;margin-top:1rem}.sura-modal-button:focus{outline:none}\n"], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibSuraModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-sura-modal',
                    templateUrl: './lib-sura-modal.component.html',
                    styleUrls: ['./lib-sura-modal.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return [{ type: i1.NgbModal }]; }, propDecorators: { alignHeader: [{
                type: Input
            }], defaultButtonText: [{
                type: Input
            }], alignBody: [{
                type: Input
            }], disableClose: [{
                type: Input
            }], type: [{
                type: Input
            }], handleSubmit: [{
                type: Output
            }] } });

class SuraModalModule {
}
SuraModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SuraModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraModalModule, declarations: [LibSuraModalComponent], imports: [CommonModule], exports: [LibSuraModalComponent] });
SuraModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraModalModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraModalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LibSuraModalComponent],
                    exports: [LibSuraModalComponent],
                    imports: [CommonModule],
                }]
        }] });

const informationModalQuery = (tenant) => {
    return `{
    allModal_informativos(tags: ["${tenant}"]) {
      edges {
        node {
          modal_informativo_por_producto {
            activar
            producto
            informacion
          }
        }
      }
    }
  }`;
};

class ContentNotFoundException extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, ContentNotFoundException.prototype);
    }
}

var MensajeError;
(function (MensajeError) {
    MensajeError["NO_SE_PUDO_CARGAR_EL_CONTENIDO"] = "No se pudo cargar el contenido";
})(MensajeError || (MensajeError = {}));

class ContenidoModalInformativoFactory {
    constructor() { }
    convertToModel(contenidoModalInformativoDTO) {
        return {
            modalInformativoPorProductos: contenidoModalInformativoDTO.modal_informativo_por_producto,
        };
    }
}
ContenidoModalInformativoFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ContenidoModalInformativoFactory, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ContenidoModalInformativoFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ContenidoModalInformativoFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ContenidoModalInformativoFactory, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return []; } });

class InformationModalService {
    constructor(prismicGraphqlService, contenidoModalInformativoFactory) {
        this.prismicGraphqlService = prismicGraphqlService;
        this.contenidoModalInformativoFactory = contenidoModalInformativoFactory;
    }
    getContenidoModalInformativo(producto, tenant) {
        return from(this.prismicGraphqlService.executeQuery(informationModalQuery(tenant))).pipe(map((response) => {
            return this.contenidoModalInformativoFactory
                .convertToModel(response.data.allModal_informativos.edges[0]
                .node)
                .modalInformativoPorProductos.find(modalInformativoPorProducto => modalInformativoPorProducto.producto === producto);
        }), catchError(() => {
            return throwError(new ContentNotFoundException(MensajeError.NO_SE_PUDO_CARGAR_EL_CONTENIDO));
        }));
    }
}
InformationModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InformationModalService, deps: [{ token: i1$1.PrismicGraphqlService }, { token: ContenidoModalInformativoFactory }], target: i0.ɵɵFactoryTarget.Injectable });
InformationModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InformationModalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InformationModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.PrismicGraphqlService }, { type: ContenidoModalInformativoFactory }]; } });

class InformationModalComponent {
    constructor(ngbModal, informationModalService, prismicUtil) {
        this.ngbModal = ngbModal;
        this.informationModalService = informationModalService;
        this.prismicUtil = prismicUtil;
    }
    ngOnInit() {
        if (this.informacion) {
            this.ngbModal.open(this.modalRef, { centered: true });
            return;
        }
        this.informationModalService
            .getContenidoModalInformativo(this.producto, this.tenant)
            .pipe(first())
            .subscribe((modalInformativoPorProducto) => {
            if (modalInformativoPorProducto) {
                this.informacion = modalInformativoPorProducto.informacion;
                if (modalInformativoPorProducto.activar) {
                    this.ngbModal.open(this.modalRef, { centered: true });
                }
            }
        });
    }
    handleCloseModal() {
        this.ngbModal.dismissAll();
    }
    handleSubmitModal() {
        this.ngbModal.dismissAll();
    }
    convertRichTextAsHTML(textToConvert) {
        return this.prismicUtil.convertTextAsHTML(textToConvert);
    }
}
InformationModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InformationModalComponent, deps: [{ token: i1.NgbModal }, { token: InformationModalService }, { token: i1$1.PrismicUtils }], target: i0.ɵɵFactoryTarget.Component });
InformationModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: InformationModalComponent, selector: "sura-information-modal", inputs: { producto: "producto", tenant: "tenant", informacion: "informacion" }, viewQueries: [{ propertyName: "modalRef", first: true, predicate: ["modalRef"], descendants: true, static: true }], ngImport: i0, template: "<ng-template #modalRef>\n  <lib-sura-modal\n    (handleSubmit)=\"handleCloseModal()\"\n    defaultButtonText=\"ENTENDIDO\"\n    class=\"lib-information-modal\"\n  >\n    <ng-container slot=\"body\">\n      <div class=\"row justify-content-center\">\n        <div class=\"edit-modal-body\">\n          <div class=\"text-center\">\n            <div [innerHTML]=\"convertRichTextAsHTML(informacion)\"></div>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n  </lib-sura-modal>\n</ng-template>\n", styles: [""], components: [{ type: LibSuraModalComponent, selector: "lib-sura-modal", inputs: ["alignHeader", "defaultButtonText", "alignBody", "disableClose", "type"], outputs: ["handleSubmit"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InformationModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sura-information-modal',
                    templateUrl: './information-modal.component.html',
                    styleUrls: ['./information-modal.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: function () { return [{ type: i1.NgbModal }, { type: InformationModalService }, { type: i1$1.PrismicUtils }]; }, propDecorators: { producto: [{
                type: Input
            }], tenant: [{
                type: Input
            }], informacion: [{
                type: Input
            }], modalRef: [{
                type: ViewChild,
                args: ['modalRef', { static: true }]
            }] } });

class SuraInformationModalModule {
}
SuraInformationModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraInformationModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SuraInformationModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraInformationModalModule, declarations: [InformationModalComponent], imports: [CommonModule, SuraModalModule], exports: [InformationModalComponent] });
SuraInformationModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraInformationModalModule, providers: [PrismicGraphqlService], imports: [[CommonModule, SuraModalModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraInformationModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SuraModalModule],
                    providers: [PrismicGraphqlService],
                    declarations: [InformationModalComponent],
                    exports: [InformationModalComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { InformationModalComponent, LibSuraModalComponent, SuraInformationModalModule, SuraModalModule };
